// LocalStorageService.js
const LocalStorageService = (function () {
  var _service;
  const authorizationData = 'ls.authorizationData';

  function _getService() {
    if (!_service) {
      _service = this;
      return _service
    }
    return _service
  }
  function _setToken(tokenObj) {
    localStorage.setItem('ls.authorizationData', JSON.stringify(tokenObj));
  }
  function _getAccessToken() {
    const authorizationData = localStorage.getItem("ls.authorizationData")

    try {
      if (authorizationData)
        return JSON.parse(authorizationData).access_token;
    } catch (err) {
      localStorage.removeItem('ls.authorizationData');
    }

  }
  function _getRefreshToken() {
    const authorizationData = localStorage.getItem("ls.authorizationData")

    if (authorizationData)
      return JSON.parse(authorizationData).refresh_token;
  }
  function _clearToken() {
    localStorage.removeItem('ls.authorizationData')
  }
  function _getRoles() {
    const authorizationData = localStorage.getItem("ls.authorizationData")

    if (authorizationData)
      return JSON.parse(authorizationData).roles
  }
  function _getUserName() {
    try {
      const authorizationData = localStorage.getItem("ls.authorizationData")

      if (authorizationData)
        return JSON.parse(authorizationData).userName
    } catch (err) {
      localStorage.removeItem('ls.authorizationData');
    }
  }
  /**
   * 
   * @param {Object} data 
   */
  const _setPreference = (data) => {
    localStorage.setItem('ls.preference', JSON.stringify(data));
  }
  const _getPreference = () => JSON.parse(localStorage.getItem('ls.preference'));
  const _setWorkspaceId = (baseServer, wsId) => {
    localStorage.setItem(`ls.wsId.${baseServer}`, wsId);
  }
  const _getWorkspaceId = (baseServer) => localStorage.getItem(`ls.wsId.${baseServer}`);
  const _removeWorkspaceId = (baseServer) => {
    localStorage.removeItem(`ls.wsId.${baseServer}`);
  }
  /**
   * 
   * @param {string} baseServer 
   * @param {Object} data 
   */
  const _setWorkspace = (baseServer, data) => {
    localStorage.setItem(`ls.workspaceData.${baseServer}.${data.id}`, JSON.stringify(data));
  }
  /**
   * 
   * @param {string} baseServer 
   * @param {number} id 
   * @returns 
   */
  const _getWorkspace = (baseServer, id) => JSON.parse(localStorage.getItem(`ls.workspaceData.${baseServer}.${id}`));
  /**
   * 
   * @param {string} baseServer 
   */
  const _clearWorkspace = (baseServer) => {
    Object.keys(localStorage).filter((key) =>
      key && key.indexOf(`ls.workspaceData.${baseServer}`) !== -1
    )
      .forEach(x => {
        localStorage.removeItem(x);
      });
    /* legacy */
    localStorage.removeItem('ls.workspaceData');
  }
  /**
   * 
   * @param {string} baseServer 
   * @param {Object} data 
   */
  const _setWebData = (baseServer, data) => {
    localStorage.setItem(`ls.webData.${baseServer}`, JSON.stringify(data));
  }
  /**
   * 
   * @param {string} baseServer 
   */
  const _getWebData = (baseServer) => {
    return JSON.parse(localStorage.getItem(`ls.webData.${baseServer}`));
  }
  /**
   * 
   * @param {string} baseServer 
   */
  const _clearWebData = (baseServer) => {
    localStorage.removeItem(`ls.webData.${baseServer}`);
  }
  /**
   * 
   * @param {string|number} moduleId 
   * @param {string|number} listingId 
   * @returns 
   */
  const _getModuleListingPreference = (moduleId, listingId) => {
    const res = localStorage.getItem(`lv.${moduleId}.${listingId}`);
    if (res) {
      try {
        return JSON.parse(res);
      } catch(err) {
        return { type: res };
      }
    }
  }
  /**
   * 
   * @param {string|number} moduleId 
   * @param {string|number} listingId 
   */
  const _setModuleListingPreference = (moduleId, listingId, data) => {
    localStorage.setItem(`lv.${moduleId}.${listingId}`, JSON.stringify(data));
  }
  /**
   * 
   * @param {string} baseServer 
   * @param {string|number} wsId 
   * @returns 
   */
  const _getStudioPreference = (baseServer, wsId) => {
    return JSON.parse(localStorage.getItem(`ls.studio.${baseServer}.${wsId}`));
  }
  /**
   * 
   * @param {string} baseServer 
   * @param {string|number} wsId 
   * @param {Object} data 
   */
  const _setStudioPreference = (baseServer, wsId, data) => {
    localStorage.setItem(`ls.studio.${baseServer}.${wsId}`, JSON.stringify(data));
  }

  return {
    getService: _getService,
    setToken: _setToken,
    getAccessToken: _getAccessToken,
    getRefreshToken: _getRefreshToken,
    clearToken: _clearToken,
    getRoles: _getRoles,
    getUserName: _getUserName,
    setPreference: _setPreference,
    getPreference: _getPreference,
    setWorkspaceId: _setWorkspaceId,
    getWorkspaceId: _getWorkspaceId,
    removeWorkspaceId: _removeWorkspaceId,
    setWorkspace: _setWorkspace,
    getWorkspace: _getWorkspace,
    clearWorkspace: _clearWorkspace,
    setWebData: _setWebData,
    getWebData: _getWebData,
    clearWebData: _clearWebData,
    getModuleListingPreference: _getModuleListingPreference,
    setModuleListingPreference: _setModuleListingPreference,
    getStudioPreference: _getStudioPreference,
    setStudioPreference: _setStudioPreference
  }
})();

export default LocalStorageService;